const resource = {
  "replenish": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Replenish"])},
  "resultsFirstName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["First name"])},
  "resultsLastName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Last name"])},
  "resultsName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name"])},
  "resultsTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Results"])},
  "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter the ID of the player for whom you want to replenish the account"])},
  "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Top up"])}
}
export default resource